import { render } from "./StickyComponent.vue?vue&type=template&id=4200d548&scoped=true"
import script from "./StickyComponent.vue?vue&type=script&lang=js"
export * from "./StickyComponent.vue?vue&type=script&lang=js"

import "./StickyComponent.vue?vue&type=style&index=0&id=4200d548&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4200d548"]])

export default __exports__